import { useModuleContext } from "@amzn/awt-module-react-utils";
import { MigrationStep, websiteContributions } from "@amzn/region-flex-interface-module-website-common";
import useSWR from "swr";

export const useMigrationSteps = () => {
  const moduleContext = useModuleContext();
  const { data } = useSWR(`moduleContributions/migrationSteps`, async () => {
    if (!moduleContext) return [];

    return moduleContext.discoverContributions<MigrationStep>(websiteContributions.migrationStep.id);
  });

  return data;
};
